import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const seoSettingApi = {
  getSeoSettings: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SEO_SETTINGS);
      return response.data;
    } catch (error) {
      console.error('Error fetching SEO settings:', error);
      throw error;
    }
  },

  getSeoSettingByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.SEO_SETTINGS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching SEO setting ${identifier}:`, error);
      throw error;
    }
  },

  createSeoSetting: async (seoSettingData) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SEO_SETTINGS, seoSettingData);
      return response.data;
    } catch (error) {
      console.error('Error creating SEO setting:', error);
      throw error;
    }
  },

  updateSeoSetting: async (identifier, seoSettingData) => {
    try {
      seoSettingData.append('_method', 'PUT'); // Laravel expects _method for PUT requests with FormData
      const response = await apiClient.post(`${API_ENDPOINTS.SEO_SETTINGS}/${identifier}`, seoSettingData);
      return response.data;
    } catch (error) {
      console.error(`Error updating SEO setting ${identifier}:`, error);
      throw error;
    }
  },
};

export default seoSettingApi;